import Alpine from '../_snowpack/pkg/alpinejs.js';

window.Alpine = Alpine;

Alpine.start();
